import React, { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import Cookies from "js-cookie";
import isEmpty from "lodash/isEmpty";

const useSession = () => {
  const [jwt] = useState(Cookies.get("jwt") || localStorage.getItem("jwt"));
  const queryClient = useQueryClient();
  const isAuthenticated = () => {
    return !isEmpty(Cookies.get("jwt") || localStorage.getItem("jwt"));
  };

  useEffect(() => {
    queryClient.setQueryData(
      "jwt",
      Cookies.get("jwt") || localStorage.getItem("jwt")
    );
  }, []);

  return [jwt, isAuthenticated];
};

export default useSession;
